import React from 'react';
import Login from '../components/Login'

class LoginPage extends React.Component {
    render() {
        return (
            <Login {...this.props} />
        )
    }
}

export default LoginPage;